import { graphql } from '@gql/gql';

export const CURRENT_ACCOUNT = graphql(`
  query CurrentAccount {
    accountMe {
      ...CurrentAccountInfo
      accountRemainingDaysForFreeApplications
      hasADog
    }
  }
`);
